import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Stethoscope, Plane, ShoppingCart, Pill, FlaskConical } from 'lucide-react';

const sectors = [
    {
        icon: Stethoscope,
        title: 'Ospedali',
        description: 'Continuità operativa per reparti critici e sale operatorie',
        image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&q=80'
    },
    {
        icon: Building2,
        title: 'Cliniche',
        description: 'Protezione per apparecchiature diagnostiche e medicali',
        image: '/images/clinica-ups.jpg'
    },
    {
        icon: Plane,
        title: 'Aeroporti',
        description: 'Sistemi critici sempre operativi, h24, 365 giorni',
        image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=600&q=80'
    },
    {
        icon: ShoppingCart,
        title: 'Supermercati',
        description: 'Protezione celle frigorifere e sistemi di cassa',
        image: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=600&q=80'
    },
    {
        icon: Pill,
        title: 'Farmacie',
        description: 'Conservazione farmaci e operatività garantita',
        image: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=600&q=80'
    },
    {
        icon: FlaskConical,
        title: 'Laboratori',
        description: 'Protezione campioni e strumentazione di precisione',
        image: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=600&q=80'
    },
];

export default function SectorsSection() {
    return (
        <section className="py-24 bg-white overflow-x-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <span className="text-sm font-medium text-blue-600 uppercase tracking-wider">I nostri clienti</span>
                    <h2 className="mt-4 text-3xl sm:text-4xl font-bold text-gray-900">
                        Settori che proteggiamo
                    </h2>
                    <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
                        Forniamo soluzioni UPS personalizzate per ogni infrastruttura critica in Sicilia
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {sectors.map((sector, index) => (
                        <motion.div
                            key={sector.title}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1 }}
                            className="group relative overflow-hidden rounded-2xl bg-gray-100 aspect-[4/3]"
                        >
                            <img
                                src={sector.image}
                                alt={sector.title}
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40 to-transparent" />

                            <div className="absolute inset-0 p-6 flex flex-col justify-end">
                                <div className="flex items-center gap-3 mb-2">
                                    <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center">
                                        <sector.icon className="w-5 h-5 text-white" />
                                    </div>
                                    <h3 className="text-xl font-semibold text-white">{sector.title}</h3>
                                </div>
                                <p className="text-gray-300 text-sm">{sector.description}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}